// ============================================================
// 用户偏好接口（shared）—— 按当前端 APP_TARGET 自动拼前缀
// ============================================================
import { http } from "@shared/utils/request";
import { APP_TARGET } from "@shared/utils/storage";

export interface UserPreferenceDetail {
    id: string;
    key: string;
    content: string;
}

export interface SaveUserPreferenceParams {
    key: string;
    content?: string;
}

/** 按 key 获取当前用户的偏好内容 */
export function getUserPreferenceDetail(key: string): Promise<UserPreferenceDetail | null> {
    return http.get<UserPreferenceDetail | null>(`/${APP_TARGET}/userPreference/detail`, { key });
}

/** 按 key 保存或更新当前用户的偏好内容 */
export function saveUserPreference(params: SaveUserPreferenceParams): Promise<void> {
    return http.post<void>(`/${APP_TARGET}/userPreference/save`, params);
}
